import React, { useEffect, useState, useContext } from "react";
import { HelpHttp } from "helpers/HelpHttp";
import ProductCrudTable from "./ProductCrudTable";
import ProductCrudTableForm from "./ProductCrudTableForm";
import ProductCrudTableSearch from "./ProductCrudTableSearch";
import SpinnerBootrap from "components/SpinnerBootrap";
import RequestError from "components/RequestError";
import Swal from "sweetalert2";
import CenterContext from "context/CenterContext";
import ProductModal from "./ProductModal";
import {
    getAll as getAllCenters,
} from "services/CenterService.js";

import {
    linkStock,
    unlinkStock,
    getOne as getOneProduct
} from 'services/ProductService';

const { REACT_APP_API } = process.env;
const initialForm = { _id: null, sku: '', skuHijo: '', name: '', priceWithoutIva: '', discount: '', netPrice: '', iva: '', totalPrice: '', haveStock: null };
let countProductsTotal = "";
let countPages = "";
let amountProductsPerPage = 5


const ProductCrud = () => {

    const [products, setProducts] = useState(null);
    const [product, setProduct] = useState({});
    const [SKU, setSKU] = useState({ sku: '' });
    const [dataToEdit, setDataToEdit] = useState(null);
    const [form, setForm] = useState(initialForm);
    const [requestError, setRequestError] = useState(null);
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [numberPageProduct, setNumberPageProduct] = useState(1);
    const [modalShow, setModalShow] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(amountProductsPerPage);
    const [hasSearch, setHasSearch] = useState(false);

    const { allCenters, setAllCenters, } = useContext(CenterContext);
    const [message, setMessage] = useState({
        message: '',
        status: 200
    })
    const { status } = message;

    let api = HelpHttp();
    let url = `${REACT_APP_API}/products`

    const editData = (el) => {
        setDataToEdit(el);
        setErrors(null);
    }
    const getCountProducts = async () => {
        await api.get(url).then(res => {
            if (res.err) {
            } else {
                countProductsTotal = res.length;
                listProducts(numberPageProduct);
            }
        });

    }

    const listProducts = async (numberPage = 1, limit = itemsPerPage) => {

        setLoading(true);

        setNumberPageProduct(numberPage);

        countPages = Math.ceil(countProductsTotal / limit);

        // ordenar por el más reciente primero
        let url2 = `${url}/?_page=${numberPage}&_limit=${limit}&_sort=createdAt&_order=desc`;

        api.get(url2).then(res => {

            if (res.err) {

                setProducts(null);
                setRequestError(res);

            } else {

                setProducts(res);
                setRequestError(null);

            }

            setLoading(false);

        });

    }
    const listProductsBySku = () => {
        countPages = 1;
        if (SKU === null || SKU.sku === "") {
            Swal.fire({
                title: 'Ingresa un valor en SKU',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            const endPoint = `${url}/${SKU.sku}/findBySku`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setProducts(null);
                    setRequestError(res);
                } else {
                    setProducts(res);
                    setRequestError(null);
                    setHasSearch(true);
                }
                setLoading(false);
            });
        }
    }
    const createData = (data) => {
        let options = { body: data, headers: { 'content-type': 'application/json' } };
        api.post(url, options).then(res => {
            if (res.err) {
                setRequestError(res);
            } else {
                if (res.status) {
                    getCountProducts();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const updateData = (data) => {
        let endPoint = `${url}/${data._id}`;
        let options = { body: data, headers: { 'content-type': 'application/json' } };
        api.put(endPoint, options).then(res => {
            console.log(res);
            if (res.err) {
                setRequestError(res);
            } else {
                if (res.status) {
                    getCountProducts();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const deleteData = (id) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, bórralo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                const endPoint = `${url}/${id}`;
                let options = { headers: { 'content-type': 'application/json' } };
                api.del(endPoint, options).then(res => {
                    console.log(res);
                    if (res.err) {
                        setRequestError(res);
                    } else {
                        if (res.status) {
                            Swal.fire('¡Eliminado!', res.message, 'success');
                            getCountProducts();
                            // handleReset();
                        } else {
                            setErrors(res.errors);
                        }
                    }
                });
            }
        });
    }
    const handleReset = (e) => {
        setErrors(null);
        setForm(initialForm);
        setDataToEdit(null);
    }

    const getCenters = async () => {
        try {
            const allCenters = await getAllCenters({});
            setAllCenters(allCenters);
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
        }
    }

    const getProduct = async ({ id }) => {
        try {
            const product = await getOneProduct({ id });
            setProduct({ ...product });
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
        }

    }

    const linkStockCenter = async ({ stockCenter, id }) => {
        try {
            const { message } = await linkStock({ stockCenter, id });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            return ''
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
            return status
        }
    }

    const unlinkStockCenter = async ({ id, stockCenterId }) => {
        try {
            const { message } = await unlinkStock({ id, stockCenterId });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            return ''
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
            return status
        }
    }

    const resetSearch = () => {
        setSKU({ sku: '' });
        setHasSearch(false);
    }

    useEffect(() => {
        if (dataToEdit) {
            setForm(dataToEdit)
        } else {
            setForm(initialForm);
        }
    }, [dataToEdit]);

    useEffect(() => {
        getCountProducts();
        getCenters();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (status !== 401) return
        localStorage.removeItem('token')
        window.location.href = "/login"
    }, [status])

    return (
        <div className="container">
            <div className="row my-md-4">
                <h4 className="d-flex justify-content-center">Mantenedor de Productos</h4>
                {requestError && <RequestError msg={requestError} />}
                <div className="col-12">
                    <ProductCrudTableSearch
                        SKU={SKU}
                        setSKU={setSKU}
                        listProductsBySku={listProductsBySku}
                    />
                </div>
                <div className="col-12">
                    <ProductCrudTableForm
                        createData={createData}
                        updateData={updateData}
                        handleReset={handleReset}
                        setDataToEdit={setDataToEdit}
                        form={form}
                        initialForm={initialForm}
                        setForm={setForm}
                        errors={errors}
                    />
                </div>
                <div className="col-12">
                    {loading && <SpinnerBootrap />}
                    {products && countProductsTotal && countPages &&
                        <ProductCrudTable
                            products={products}
                            editData={editData}
                            deleteData={deleteData}
                            listProducts={listProducts}
                            countProductsTotal={countProductsTotal}
                            countPages={countPages}
                            setModalShow={setModalShow}
                            setProduct={setProduct}
                            itemsPerPage={itemsPerPage}
                            setItemsPerPage={setItemsPerPage}
                            resetSearch={resetSearch}
                            hasSearched={hasSearch}
                        />}
                </div>
            </div>

            <ProductModal
                modalShow={modalShow}
                setModalShow={setModalShow}
                allCenters={allCenters}
                product={product}
                products={products}
                setProduct={setProduct}
                linkStockCenter={linkStockCenter}
                unlinkStockCenter={unlinkStockCenter}
                message={message}
                setMessage={setMessage}
                getProduct={getProduct}
                getCountProducts={getCountProducts}

            >
            </ProductModal>
        </div>
    );
}
export default ProductCrud;
